import { render, staticRenderFns } from "./problemCheckTaskIndex.vue?vue&type=template&id=40ba6f81&scoped=true&"
import script from "./problemCheckTaskIndex.vue?vue&type=script&lang=js&"
export * from "./problemCheckTaskIndex.vue?vue&type=script&lang=js&"
import style0 from "./problemCheckTaskIndex.vue?vue&type=style&index=0&id=40ba6f81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ba6f81",
  null
  
)

export default component.exports